const dropper_types = [
    "dropper",
    "microtube",
    "integrated",
    "selfCompensated",
];
export default dropper_types;